import { BehaviorType } from "../types";
import Behavior from "../types/Behavior";
class BeforeUnloadBehavior extends Behavior {
    constructor(plasm, appName, addMetadata) {
        super(plasm, appName, addMetadata);
        this.id = BehaviorType.beforeunload;
    }
}
export default BeforeUnloadBehavior;
